const stylesInput = (orientationLandscape) => ({
  padding: "0",
  margin: "0",
  marginTop: orientationLandscape ? "15px" : "25px",
  backgroundColor: "white",
  height: "46px",
  border: "1px solid rgb(194,199,202)",
  width: "72vw",
  paddingLeft: "2.6vw",
  fontSize: "16px",
  background: "rgb(232,240,254)",
});

const styles = (orientationLandscape) => ({
  loginFormTabs: {
    width: "calc(75vw + 32px)",
    marginTop: orientationLandscape ? "12px" : "20px",
    marginBottom: 0,
    marginLeft: "auto",
    marginRight: "auto",
  },
  loginForm: {
    width: "75vw",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: 0,
  },
  passwordInput: stylesInput(orientationLandscape),
  phonePostInput: stylesInput(orientationLandscape),
  userNameInput: stylesInput(orientationLandscape),
  submitButton: {
    backgroundColor: "rgb(33,77,142)",
    width: "75vw",
    height: "51px",
    border: "1px solid rgb(33,77,142)",
    borderRadius: "0px",
    marginTop: orientationLandscape ? "15px" : "25px",
  },
  errorMessage: {
    fontSize: "2.2vh",
    color: "rgb(255,99,71)",
    textAlign: "center",
  },
  fieldErrorMessage: {
    fontSize: "14px",
    color: "rgb(255,99,71)",
    position: "absolute",
    // left: "50%",
    // transform: "translateX(-50%)",
    lineHeight: "1.2em",
    marginTop: "4px",
  },
  spinner: {
    marginTop: "10vh",
  },
  inactiveTab: {
    color: "black",
    fontWeight: "600",
  },
  activeTab: {
    color: "#000",
    fontWeight: "700",
  },
  usernameInputWrapper: {
    padding: "0",
    margin: "0",
    position: "relative",
  },
  passwordInputWrapper: {
    padding: "0",
    margin: "0",
    position: "relative",
  },
  showPasswordText: {
    color: "rgb(21,117,180)",
    fontSize: "12px",
    position: "absolute",
    top: orientationLandscape ? "29px" : "39px",
    right: "12px",
  },
  inputLabel: {
    position: "relative",
    fontSize: "10px",
    color: "rgb(163,164,165)",
    left: "11px",
    top: "-50px",
  },
  dontKnowPassword: {
    textDecoration: "none",
    color: "rgb(0,99,173)",
  },
});

export default styles;
